var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCap = function SvgCap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.061 1.574.758 6.727a.842.842 0 0 0 0 1.472l9.304 5.153a6.672 6.672 0 0 0 6.467 0l5.894-3.265V8.423H12.335v-.96h11.048v2.092l2.45-1.356a.843.843 0 0 0 0-1.472l-9.305-5.153a6.668 6.668 0 0 0-6.467 0Zm13.322 11.173.48 2.882v3.843h-1.92v-3.843l.48-2.882v-2.66l.96-.532v3.192Zm-16.32 1.141c-.252 1.78-.668 3.157-.7 3.266l-.003.007c-.96 1.53.691 1.17.691 1.17 1.28.022 2.555.915 3.56 1.625.418.296.835.6 1.208.952.549.517 1.143 1.006 1.941.723.409-.144.706-.422 1.007-.718 3.032-2.972 5.224-2.552 5.224-2.552.372.07.888-.007.894-.461.003-.224-.12-.41-.24-.592a2.304 2.304 0 0 1-.152-.255c-.48-.997-.53-2.247-.498-3.424l-2.535 1.404a8.625 8.625 0 0 1-4.164 1.077 8.624 8.624 0 0 1-4.165-1.077l-2.067-1.145Z",
    fill: "#fff"
  })));
};
export default SvgCap;